import _camelCase from "lodash/camelCase";
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import * as React from 'react';
import Toast from '../Toast';
import { jsx as _jsx } from "react/jsx-runtime";
const useStyles = makeStyles(theme => ({
  container: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    zIndex: theme.zIndex.snackbar,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    pointerEvents: 'none'
  },
  topLeft: {
    right: 'auto'
  },
  topRight: {
    left: 'auto'
  },
  top: {},
  bottomLeft: {
    justifyContent: 'flex-end',
    right: 'auto'
  },
  bottomRight: {
    justifyContent: 'flex-end',
    left: 'auto'
  },
  bottom: {
    justifyContent: 'flex-end'
  },
  toast: {
    pointerEvents: 'auto',
    '$topLeft &': {
      maxWidth: 344
    },
    '$topRight &': {
      maxWidth: 344
    },
    '$bottomLeft &': {
      maxWidth: 344
    },
    '$bottomRight &': {
      maxWidth: 344
    },
    '$bottom &': {
      overflowY: 'auto'
    }
  }
}));
function Toaster(props) {
  const {
    placement = 'top-right',
    toasts,
    onDismiss
  } = props;
  const classes = useStyles();
  const makeOnDimiss = React.useCallback(toast => {
    if (!onDismiss) {
      return undefined;
    }
    return () => {
      onDismiss(toast.id, toast);
    };
  }, [onDismiss]);
  return _jsx(Box, {
    className: clsx(classes.container, classes[_camelCase(placement)]),
    "data-screenshot-ignore": true,
    children: toasts.map(toast => {
      return _jsx("div", {
        className: classes.toast,
        children: _jsx(Toast, {
          variant: toast.type,
          timeout: toast.timeout,
          disableProgress: toast.disableProgress,
          onClose: makeOnDimiss(toast),
          children: toast.body
        })
      }, toast.id);
    })
  });
}
export default Toaster;